import DeployToWorldAnnouncementModal from './DeployToWorldAnnouncementModal.container'

export default DeployToWorldAnnouncementModal
